export const convertDate = (date)=>{
    const monthNames = [
        "January", "February", "March", "April", "May", "June",
"July", "August", "September", "October", "November", "December"
    ];
    const newDate = new Date(date);
    return monthNames[newDate.getMonth()] + " " + ("0" + newDate.getDate()).slice(-2) + "," + newDate.getFullYear();
}